import PropTypes from 'prop-types';
import classNames from 'classnames';
import React, { PureComponent } from 'react';
import withStyles from 'isomorphic-style-loader/withStyles'

import Button from '../Button';
import { withRtl } from '../hoc';
import style from './ButtonAction.scss';

class ButtonAction extends PureComponent {
  static defaultProps = {
    label: 'Submit',
    ariaLabel: '',
    large: false,
    small: false,
  };
  static propTypes = {
    label: PropTypes.node,
    ariaLabel: PropTypes.string,
    large: PropTypes.bool,
    small: PropTypes.bool,
    icon: PropTypes.string.isRequired,
  };

  render() {
    const { icon, label, large, ariaLabel } = this.props;
    const textClass = classNames(style.text, { [style.textLarge]: large });
    const actionClass = classNames(style.action, { [style.actionLarge]: large });
    return (
      <Button {...this.props} ariaLabel={ariaLabel || label} action>
        <div className={textClass}>{label}</div>
        <div className={actionClass}>
          <i className={`icon-${icon}`} role="presentation" />
        </div>
      </Button>
    );
  }
}

export { ButtonAction };
export default withRtl(style)(withStyles(style)(ButtonAction));
